import { z } from 'zod'

export const loginSearchSchema = z
  .object({
    mode: z.enum(['activated', 'updated', 'verifyEmail']).optional(),
    token: z.string().optional()
  })
  .superRefine((search, ctx) => {
    if (search.mode === 'verifyEmail' && !search.token) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'token is required when mode is verifyEmail',
        path: ['token']
      })
    }
  })
